export type StatusType = 'error' | 'primary' | 'warning' | 'secondary' | 'info' | 'success';

export const lineItemFormText = {
  importButtonLabel: 'Import Settings From An Existing Line Item',
  changelogButtonLabel: 'See Changelog',
  lineItemNewSave: 'Create Line Item',
  lineItemNewCancel: 'Cancel',
  lineItemEditSave: 'Save Line Item',
  lineItemHeader: {
    new: 'Create New Line Item',
    edit: 'Edit Line Item',
    status: 'Status: ',
  },
  sectionTitles: {
    objectives: 'Line Item Objectives',
    general: 'General',
    mediaAndChannels: 'Media & Channels',
    timing: 'Timing',
    reporting: 'Reporting',
    budgetRates: 'Budget & Rates',
  },
  subsectionTitles: {
    flightDates: 'Flight Dates',
    dayParting: 'Day Parting',
    adDelivery: 'Ad Delivery',
    costFeatures: 'Cost Incurring Features',
    budget: 'Budget',
    reportLinks: 'Report Links',
    rate: 'Rate',
    optimization: 'Optimization',
    bidding: 'Bidding',
    selectionAlgorithm: 'Selection Algorithm',
    spendPacing: 'Dynamic Spend Pacing',
    deliveryDiagnostics: 'Delivery Diagnostics',
  },
  deliveryDiagnostics: {
    impressionBudgetLabel: 'Impression Budget',
    deliveredImpressionsLabel: 'Delivered Impressions',
    // Pacing runs to deliver until Delivered Impressions >= Impression Budget
    // (Admin::InsertionOrder#over_budget?). Surfaced read-only so Ad Ops can
    // spot budget/impression mismatches without pulling from the backend.
    tip: 'The line item paces to deliver until Delivered Impressions reaches Impression Budget.',
  },
  impressionLimitTip:
    '(If your daily impression limit is below the equal daily impression share of your requested budget, underdelivery is possible.)',
};

export const lineItemStatusMap = {
  incomplete: ['Incomplete', 'status-red', 'default'],
  draft: ['Draft', 'status-black', 'default'],
  not_spending: ['Not Spending', 'status-green', 'primary'],
  pre_launch: ['Pre Launch', 'status-green', 'primary'],
  questionable: ['Questionable', 'status-yellow', 'warning'],
  scheduled: ['Scheduled', 'status-green', 'primary'],
  spending: ['Spending', 'status-green', 'primary'],
  ended: ['Ended', 'status-black', 'default'],
};

export const POPULATION_DENSITY_PACING_SEED_TYPE_LABEL = 'Population Density Pacing';

export const CTR_KPI_OPTION = {
  label: 'CTR',
  value: 'CTR',
  defaultValue: '0.2',
  type: 'secondaryKpi',
};

export const VCR_KPI_OPTION = {
  label: 'VCR',
  value: 'VCR',
  defaultValue: '0.8',
  type: 'secondaryKpi',
};

// Conversion is a scored-list-only Secondary KPI: it feeds scored_list_metric but
// carries no numeric goal (value is the '0' sentinel, and its goal input is hidden).
// Selecting a Primary KPI auto-switches the Secondary KPI to Conversion.
export const CONVERSION_KPI_OPTION = {
  label: 'Conversion',
  value: 'Conversion',
  defaultValue: '0',
  type: 'secondaryKpi',
};

export const SECONDARY_KPI_OPTIONS = [
  CTR_KPI_OPTION,
  VCR_KPI_OPTION,
  CONVERSION_KPI_OPTION,
  {
    label: 'Viewability',
    value: 'Views',
    disabled: true,
    type: 'secondaryKpi',
  },
];

// Shown when a user overrides the Conversion Secondary KPI back to CTR/VCR while a
// Primary (conversion-based) KPI is selected.
export const CONVERSION_SCORED_LIST_WARNING =
  'Conversion-based KPIs perform best with a conversion-optimized scored list. Are you sure?';

// ADOPS-2556: Data Science requires a minimum device count to build modeled audiences
// from a Receipts selection. Their hard floor is 10k, but they recommend 25k as a buffer
// for devices lost to joins, dedupe across selections, etc. Counts below this render red.
export const RECEIPT_DEVICE_COUNT_THRESHOLD = 25000;
